module.exports = __webpack_public_path__ + "img/excel.97f72c34.svg";